import { Directive, OnDestroy } from '@angular/core';
import { Exercicio, FuncaoService, GlobalService, Login, Relatorio } from 'eddydata-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BalancoService } from '../service/balanco.service';

@Directive()
export class Anexo121Balanco implements OnDestroy {
  protected funcaoService: FuncaoService;
  protected globalService: GlobalService;
  private login: Login = new Login();
  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected balancoServico: BalancoService,
    protected exercicio: Exercicio) {
    this.funcaoService = new FuncaoService();
    this.globalService = new GlobalService();
    this.login = GlobalService.obterSessaoLogin();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public montarRelatorio(exercicio: Exercicio, orgaos: number[]) {
    this.balancoServico.obterBalancoOrcamentarioRPNaoProcessado(this.exercicio.id, orgaos)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        Relatorio.imprimirPersonalizado(
          `ANEXO 12.1 - DEMONSTRATIVO DE EXECUÇÃO DE RESTOS A PAGAR NÃO PROCESSADO`
          , this.login.usuario.nome,
          this.login.orgao.nome, this.login.brasao,
          this.conteudo(dados, exercicio),
          'landscape', 'ANEXO 12.1 - DEMONSTRATIVO DE EXECUÇÃO DE RESTOS A PAGAR NÃO PROCESSADO',
          {
            linhas: {
              hLineWidth() {
                return 1;
              },
              vLineWidth() {
                return 1;
              },
              hLineColor() {
                return 'black';
              },
              paddingLeft() {
                return 3;
              },
              paddingRight() {
                return 3;
              }
            }
          });
      });
  }

  private conteudo(dados: any[], exercicio: Exercicio): {}[] {
    // monta o cabecalho
    const registros: {}[] = [
      [{
        text: `EXERCÍCIO ${exercicio.ano}`, fontSize: 12,
        alignment: 'center', bold: true, colSpan: 6, border: [true, true, true, false]
      }, '', '', '', '', ''],
      [{
        text: 'RESTOS A PAGAR NÃO PROCESSADOS',
        alignment: 'center',
        fontSize: 7,
        bold: true,
        rowSpan: 2
      }, {
        text: 'INSCRITOS',
        alignment: 'center',
        fontSize: 7,
        bold: true,
        colSpan: 2
      }, {
        text: '',
        alignment: 'center',
        fontSize: 7,
        bold: true,
      }, {
        text: 'LIQUIDADOS  (c)',
        alignment: 'center',
        fontSize: 7,
        bold: true,
        rowSpan: 2
      }, {
        text: 'PAGOS (d)',
        alignment: 'center',
        fontSize: 7,
        bold: true,
        rowSpan: 2
      }, {
        text: 'CANCELADOS (e)',
        alignment: 'center',
        fontSize: 7,
        bold: true,
        rowSpan: 2
      }, {
        text: 'SALDO (f)=(a+b-d-e)',
        alignment: 'center',
        fontSize: 7,
        bold: true,
        rowSpan: 2
      }],
      [
        { text: '' },
        {
          text: 'EM EXERCÍCIOS ANTERIORES (a)',
          alignment: 'center',
          fontSize: 7,
          bold: true,
        }, {
          text: 'EM 31 DE DEZEMBRO DO EXERCÍCIO (b)',
          alignment: 'center',
          fontSize: 7,
          bold: true,
        },
        { text: '' },
        { text: '' },
        { text: '' },
        { text: '' }
      ]
    ];


    const grupos = this.funcaoService.agrupar(dados, 'tipo',
      ['anterior', 'doexercicio', 'liquidado', 'pago', 'cancelado']);

    const totalizador = new Array<any>();
    let col2 = 0;
    let col3 = 0;
    let col4 = 0;
    let col5 = 0;
    let col6 = 0;
    let col7 = 0;
    for (const grupo of grupos) {
      registros.push([
        {
          text: grupo.grupo, bold: true, fontSize: 7
        },
        {
          text: this.funcaoService.convertToBrNumber(
            grupo.totalizadores['anterior']), alignment: 'right', bold: true, fontSize: 7
        },
        {
          text: this.funcaoService.convertToBrNumber(
            grupo.totalizadores['doexercicio']), alignment: 'right', bold: true, fontSize: 7
        },
        {
          text: this.funcaoService.convertToBrNumber(
            grupo.totalizadores['liquidado']), alignment: 'right', bold: true, fontSize: 7
        },
        {
          text: this.funcaoService.convertToBrNumber(
            grupo.totalizadores['pago']), alignment: 'right', bold: true, fontSize: 7
        },
        {
          text: this.funcaoService.convertToBrNumber(
            grupo.totalizadores['cancelado']), alignment: 'right', bold: true, fontSize: 7
        },
        {
          text: this.funcaoService.convertToBrNumber(
            (+grupo.totalizadores['anterior'] + +grupo.totalizadores['doexercicio']) - (+grupo.totalizadores['pago'] - +grupo.totalizadores['cancelado'])), alignment: 'right', bold: true, fontSize: 7
        }
      ]);

      // lista dos registros do grupo
      for (const registro of grupo.registros) {
        registros.push([
          {
            text: `${registro.nome}`, fontSize: 7
          },
          { text: this.funcaoService.convertToBrNumber(registro.anterior), alignment: 'right', fontSize: 7 },
          { text: this.funcaoService.convertToBrNumber(registro.doexercicio), alignment: 'right', fontSize: 7 },
          { text: this.funcaoService.convertToBrNumber(registro.liquidado), alignment: 'right', fontSize: 7 },
          { text: this.funcaoService.convertToBrNumber(registro.pago), alignment: 'right', fontSize: 7 },
          { text: this.funcaoService.convertToBrNumber(registro.cancelado), alignment: 'right', fontSize: 7 },
          {
            text: this.funcaoService.convertToBrNumber((
              +registro.anterior + +registro.doexercicio) - (+registro.pago + +registro.cancelado)), alignment: 'right', fontSize: 7
          }
        ]);
      }


      col2 += +grupo.totalizadores['anterior'];
      col3 += +grupo.totalizadores['doexercicio'];
      col4 += +grupo.totalizadores['liquidado'];
      col5 += +grupo.totalizadores['pago'];
      col6 += +grupo.totalizadores['cancelado'];
      col7 += (+grupo.totalizadores['anterior'] + +grupo.totalizadores['doexercicio']) - (+grupo.totalizadores['pago'] + +grupo.totalizadores['cancelado']);

    }

    registros.push([{
      text: 'TOTAL', bold: true,
      alignment: 'left', fontSize: 7
    }, {
      text: this.funcaoService.convertToBrNumber(col2),
      alignment: 'right', bold: true, fontSize: 7
    }, {
      text: this.funcaoService.convertToBrNumber(col3),
      alignment: 'right', bold: true, fontSize: 7
    }, {
      text: this.funcaoService.convertToBrNumber(col4),
      alignment: 'right', bold: true, fontSize: 7
    }, {
      text: this.funcaoService.convertToBrNumber(col5),
      alignment: 'right', bold: true, fontSize: 7
    }, {
      text: this.funcaoService.convertToBrNumber(col6),
      alignment: 'right', bold: true, fontSize: 7
    }, {
      text: this.funcaoService.convertToBrNumber(col7),
      alignment: 'right', bold: true, fontSize: 7
    }]);

    return [{
      layout: 'linhas',
      table: {
        dontBreakRows: true,
        headerRows: 2,
        widths: ['*', 80, 80, 80, 80, 80, 80],
        body: registros
      }
    }];
  }

}
